<template>
  <article class="ai-visibility-metric-card">
    <div class="ai-visibility-metric-card__title">
      <span>{{ title }}</span>
      <info-icon v-if="infoTitle" :info="{tooltip: infoTitle}"/>
    </div>
    <div
        class="ai-visibility-metric-card__value"
        :class="valueTone ? `ai-visibility-metric-card__value--${valueTone}` : ''"
    >
      <span :style="valueFontSize">{{ value }}</span><span v-if="suffix" class="ai-visibility-metric-card__suffix">{{ suffix }}</span>
    </div>
    <p v-if="description || $slots.description">
      <slot name="description">{{ description }}</slot>
    </p>
    <trend-badge
        v-if="trend"
        :direction="trend.direction"
        :tone="trend.tone"
        :label="trend.label"
    />
  </article>
</template>

<script>
import InfoIcon from '../display/InfoIcon.vue'
import TrendBadge from '../display/TrendBadge.vue'

export default {
  name: 'MetricCard',
  components: {
    InfoIcon,
    TrendBadge,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    suffix: {
      type: String,
      default: '',
    },
    valueTone: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    trend: {
      type: Object,
      default: null,
    },
    infoTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    valueFontSize () {
      let size = 36;
      const extraLetters = this.value.length - 16;
      if (extraLetters > 0) {
        size = Math.max(24, 36 - 2 * extraLetters)
      }

      return {fontSize: `${size}px`}
    }
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-metric-card {
  align-items: flex-start;
  background: var(--v-cardBg-base);
  border-radius: 8px;
  border: 1px solid var(--v-gray13Color-base);
  box-shadow: 0 5px 2px 0 rgba(0, 0, 0, 0.01), 0 3px 2px 0 rgba(0, 0, 0, 0.04), 0 1px 1px 0 rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  min-height: 150px;
  padding: 18px;

  &.main-card {
    border: 1px solid var(--v-lightYellow1Color-base);
    background: linear-gradient(69deg, var(--v-whiteColor-base) 65.79%, var(--v-lightYellow2Color-base) 98.62%);
  }

}

.ai-visibility-metric-card__title {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  color: var(--v-mainGreen-base);
  font-weight: 500;

  span {
    font-size: 20px;
  }

}

.ai-visibility-metric-card__value {
  color: var(--v-mainColor-base);
  font-weight: 700;
  line-height: 1.5;

  span {
    font-size: 36px;
    line-height: 1.5;
  }

  .ai-visibility-metric-card__suffix {
    font-size: 20px;
    margin-left: 0;
  }

}

.ai-visibility-metric-card__value--negative {
  color: #FF4040;
}

.ai-visibility-metric-card p {
  color: var(--v-darkGrayColor-base);
  font-size: 16px;
  line-height: 1.45;
  margin: 0;
}
</style>
